module.exports = __webpack_public_path__ + "node_modules/icheck/skins/square/aero@2x.png?e87893c9";